// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"38":"d09834b4e0c0e8ab","440":"42146e9ee65fb35c","581":"d2b03e0eefdc45ff"}[chunkId] + ".js";
};